module.exports = __webpack_public_path__ + "resources/img/img-deep-security-01-2.7bd3810891565da08aec29684daa9588.png";